const OPENINGS = "\uFF08\uFF3B\uFF5B\u3014\u3008\u300A\u300C\u300E\u3010\u3018\u3016\u201C\u2018";
const CLOSINGS = "\uFF09\uFF3D\uFF5D\u3015\u3009\u300B\u300D\u300F\u3011\u3019\u3017\u201D\u2019";
const MIDDLE_DOTS = "\u30FB\uFF1A\uFF1B";
const COMMAS = "\u3001\uFF0C";
const PERIODS = "\u3002\uFF0E";
const latinRegex = /[\p{scx=Latin}0-9⁰¹²³⁴-⁾₀-₎¢¤$€£¥+−×÷=≠><≥≤±≈~¬∅∞∫∏∑√∂%‰@&.,:;!¡?¿'"‘’“”\-(){}[\]|/\\^_`*#\s]+/gu;
const latinTestRegex = new RegExp(latinRegex.source, "u");
const openingsRegex = new RegExp(`[${OPENINGS}]`);
const closingsRegex = new RegExp(`[${CLOSINGS}]`);
const middleDotsRegex = new RegExp(`[${MIDDLE_DOTS}]`);
const commasRegex = new RegExp(`[${COMMAS}]`);
const periodsRegex = new RegExp(`[${PERIODS}]`);
const spaceAfterRegex = new RegExp(`[${CLOSINGS}${COMMAS}${PERIODS}]`);
const japaneseRegex = new RegExp(
  `[\\p{scx=Hiragana}\\p{scx=Katakana}\uFF66-\uFF9F\\p{scx=Han}${OPENINGS}${CLOSINGS}${MIDDLE_DOTS}${COMMAS}${PERIODS}]`,
  "u"
);
const punctuationRegex = new RegExp(`[,.${OPENINGS}${CLOSINGS}${MIDDLE_DOTS}${COMMAS}${PERIODS}]`);
const noBreakRulesRegex = /[—‥…＿─-╿]+/g;
const noBreakRulesTestRegex = new RegExp(noBreakRulesRegex.source);
const whitespaceRegex = /\s/;
const whitespaceOnlyRegex = /^\s*$/;
const latinOrDigitRegex = /[\p{sc=Latin}0-9]/u;
const cjkLetterRegex = /[\p{sc=Hiragana}\p{sc=Katakana}\p{sc=Han}]/u;
export {
  cjkLetterRegex,
  closingsRegex,
  commasRegex,
  japaneseRegex,
  latinOrDigitRegex,
  latinRegex,
  latinTestRegex,
  middleDotsRegex,
  noBreakRulesRegex,
  noBreakRulesTestRegex,
  openingsRegex,
  periodsRegex,
  punctuationRegex,
  spaceAfterRegex,
  whitespaceOnlyRegex,
  whitespaceRegex
};
